module.exports = __webpack_public_path__ + "static/audio-vultures-share-2c9ea2eb01bf78f6bdc658ec70ee45bb.jpg";